/**
 * Work Listings block: tabs load content via AJAX; load more via AJAX.
 */
import './style.scss';

document.addEventListener('DOMContentLoaded', initWorkListings);

function loadPanelContent(block, panel) {
	const ajaxUrl = block.getAttribute('data-ajax-url') || '';
	const nonce = block.getAttribute('data-loadmore-nonce') || '';
	const perPage = block.getAttribute('data-per-page') || '12';
	const termId = panel.getAttribute('data-term-id');
	const grid = panel.querySelector('.work-listings__grid');
	const loadingEl = panel.querySelector('.work-listings__loading');
	const loadMoreWrap = panel.querySelector('.work-listings__load-more-wrap');
	if (!grid || !ajaxUrl || !termId) return;

	loadingEl?.removeAttribute('hidden');
	const formData = new FormData();
	formData.append('action', 'filminnepal_work_listings_load_more');
	formData.append('nonce', nonce);
	formData.append('term_id', termId);
	formData.append('page', '1');

	fetch(ajaxUrl, {
		method: 'POST',
		body: formData,
		credentials: 'same-origin',
	})
		.then((res) => res.json())
		.then((json) => {
			loadingEl?.setAttribute('hidden', '');
			if (!json.success || !json.data) return;
			grid.innerHTML = json.data.html || '';
			panel.setAttribute('data-loaded', '1');
			panel.setAttribute('data-page', '1');
			if (json.data.has_more && loadMoreWrap) {
				loadMoreWrap.classList.remove('is-hidden');
				loadMoreWrap.innerHTML =
					'<button type="button" class="btn btn--outline work-listings__load-more" data-term-id="' +
					termId +
					'" data-page="1" data-per-page="' +
					perPage +
					'">' +
					(block.getAttribute('data-load-more-text') || 'Load more') +
					'</button>';
			}
		})
		.catch(() => {
			loadingEl?.setAttribute('hidden', '');
		});
}

function initWorkListings() {
	document.querySelectorAll('.work-listings').forEach((block) => {
		const tabs = block.querySelectorAll('.work-listings__tab');
		const panels = block.querySelectorAll('.work-listings__panel');
		const ajaxUrl = block.getAttribute('data-ajax-url') || '';
		const nonce = block.getAttribute('data-loadmore-nonce') || '';

		// Load active tab content on init
		const activePanel = block.querySelector(
			'.work-listings__panel.is-active'
		);
		if (activePanel && activePanel.getAttribute('data-loaded') === '0') {
			loadPanelContent(block, activePanel);
		}

		tabs.forEach((tab) => {
			tab.addEventListener('click', () => {
				const index = tab.getAttribute('data-tab-index');
				if (index === null) return;

				tabs.forEach((t) => {
					t.classList.remove('is-active');
					t.setAttribute('aria-selected', 'false');
				});
				tab.classList.add('is-active');
				tab.setAttribute('aria-selected', 'true');

				panels.forEach((panel, i) => {
					const isActive = String(i) === index;
					panel.classList.toggle('is-active', isActive);
					panel.hidden = !isActive;
					if (isActive && panel.getAttribute('data-loaded') === '0') {
						loadPanelContent(block, panel);
					}
				});
			});
		});

		// Load more: event delegation (works for dynamically added buttons)
		block.addEventListener('click', (e) => {
			const btn = e.target.closest('.work-listings__load-more');
			if (!btn) return;
			const panel = btn.closest('.work-listings__panel');
			const grid = panel?.querySelector('.work-listings__grid');
			if (!grid || !ajaxUrl) return;

			const termId = btn.getAttribute('data-term-id');
			let page = parseInt(btn.getAttribute('data-page') || '1', 10);
			if (!termId) return;

			btn.disabled = true;
			btn.setAttribute('aria-busy', 'true');

			const formData = new FormData();
			formData.append('action', 'filminnepal_work_listings_load_more');
			formData.append('nonce', nonce);
			formData.append('term_id', termId);
			formData.append('page', String(page + 1));

			fetch(ajaxUrl, {
				method: 'POST',
				body: formData,
				credentials: 'same-origin',
			})
				.then((res) => res.json())
				.then((json) => {
					if (json.success && json.data && json.data.html) {
						grid.insertAdjacentHTML('beforeend', json.data.html);
						page = json.data.page;
						btn.setAttribute('data-page', String(page));
						if (!json.data.has_more) {
							btn.closest(
								'.work-listings__load-more-wrap'
							)?.classList.add('is-hidden');
						}
					}
				})
				.catch(() => {})
				.finally(() => {
					btn.disabled = false;
					btn.removeAttribute('aria-busy');
				});
		});
	});
}
